"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4474],{

/***/ 86598:
/***/ (function(module) {



/**
 * Used to mark a
 * [React Native `File` substitute]{@link ReactNativeFileSubstitute}
 * in an object tree for [`extractFiles`]{@link extractFiles}. It’s too risky to
 * assume all objects with `uri`, `type` and `name` properties are files to
 * extract.
 * @kind class
 * @name ReactNativeFile
 * @param {ReactNativeFileSubstitute} file A [React Native](https://reactnative.dev) [`File`](https://developer.mozilla.org/en-US/docs/Web/API/File) substitute.
 * @example <caption>Ways to `import`.</caption>
 * ```js
 * import { ReactNativeFile } from 'extract-files';
 * ```
 *
 * ```js
 * import ReactNativeFile from 'extract-files/public/ReactNativeFile.js';
 * ```
 * @example <caption>Ways to `require`.</caption>
 * ```js
 * const { ReactNativeFile } = require('extract-files');
 * ```
 *
 * ```js
 * const ReactNativeFile = require('extract-files/public/ReactNativeFile.js');
 * ```
 * @example <caption>An extractable file in [React Native](https://reactnative.dev).</caption>
 * ```js
 * const file = new ReactNativeFile({
 *   uri: uriFromCameraRoll,
 *   name: 'a.jpg',
 *   type: 'image/jpeg',
 * });
 * ```
 */
module.exports = class ReactNativeFile {
  constructor({ uri, name, type }) {
    this.uri = uri;
    this.name = name;
    this.type = type;
  }
};


/***/ }),

/***/ 96350:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {



const defaultIsExtractableFile = __webpack_require__(13954);

/**
 * Clones a value, recursively extracting
 * [`File`](https://developer.mozilla.org/en-US/docs/Web/API/File),
 * [`Blob`](https://developer.mozilla.org/en-US/docs/Web/API/Blob) and
 * [`ReactNativeFile`]{@link ReactNativeFile} instances with their
 * [object paths]{@link ObjectPath}, replacing them with `null`.
 * [`FileList`](https://developer.mozilla.org/en-US/docs/Web/API/Filelist) instances
 * are treated as [`File`](https://developer.mozilla.org/en-US/docs/Web/API/File)
 * instance arrays.
 * @kind function
 * @name extractFiles
 * @param {*} value Value (typically an object tree) to extract files from.
 * @param {ObjectPath} [path=''] Prefix for object paths for extracted files.
 * @param {ExtractableFileMatcher} [isExtractableFile=isExtractableFile] The function used to identify extractable files.
 * @returns {ExtractFilesResult} Result.
 * @example <caption>Ways to `import`.</caption>
 * ```js
 * import { extractFiles } from 'extract-files';
 * ```
 *
 * ```js
 * import extractFiles from 'extract-files/public/extractFiles.js';
 * ```
 * @example <caption>Ways to `require`.</caption>
 * ```js
 * const { extractFiles } = require('extract-files');
 * ```
 *
 * ```js
 * const extractFiles = require('extract-files/public/extractFiles.js');
 * ```
 * @example <caption>Extract files from an object.</caption>
 * For the following:
 *
 * ```js
 * const file1 = new File(['1'], '1.txt', { type: 'text/plain' });
 * const file2 = new File(['2'], '2.txt', { type: 'text/plain' });
 * const value = {
 *   a: file1,
 *   b: [file1, file2],
 * };
 *
 * const { clone, files } = extractFiles(value, 'prefix');
 * ```
 *
 * `value` remains the same.
 *
 * `clone` is:
 *
 * ```json
 * {
 *   "a": null,
 *   "b": [null, null]
 * }
 * ```
 *
 * `files` is a [`Map`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map) instance containing:
 *
 * | Key     | Value                        |
 * | :------ | :--------------------------- |
 * | `file1` | `['prefix.a', 'prefix.b.0']` |
 * | `file2` | `['prefix.b.1']`             |
 */
module.exports = function extractFiles(
  value,
  path = '',
  isExtractableFile = defaultIsExtractableFile
) {
  // Map of extracted files and their object paths within the input value.
  const files = new Map();

  // Map of arrays and objects recursed within the input value and their clones,
  // for reusing clones of values that are referenced multiple times within the
  // input value.
  const clones = new Map();

  /**
   * Recursively clones the value, extracting files.
   * @kind function
   * @name extractFiles~recurse
   * @param {*} value Value to extract files from.
   * @param {ObjectPath} path Prefix for object paths for extracted files.
   * @param {Set} recursed Recursed arrays and objects for avoiding infinite recursion of circular references within the input value.
   * @returns {*} Clone of the value with files replaced with `null`.
   * @ignore
   */
  function recurse(value, path, recursed) {
    let clone = value;

    if (isExtractableFile(value)) {
      clone = null;

      const filePaths = files.get(value);

      filePaths ? filePaths.push(path) : files.set(value, [path]);
    } else {
      const isList =
        Array.isArray(value) ||
        (typeof FileList !== 'undefined' && value instanceof FileList);
      const isObject = value && value.constructor === Object;

      if (isList || isObject) {
        const hasClone = clones.has(value);

        if (hasClone) clone = clones.get(value);
        else {
          clone = isList ? [] : {};

          clones.set(value, clone);
        }

        if (!recursed.has(value)) {
          const pathPrefix = path ? `${path}.` : '';
          const recursedDeeper = new Set(recursed).add(value);

          if (isList) {
            let index = 0;

            for (const item of value) {
              const itemClone = recurse(
                item,
                pathPrefix + index++,
                recursedDeeper
              );

              if (!hasClone) clone.push(itemClone);
            }
          } else
            for (const key in value) {
              const propertyClone = recurse(
                value[key],
                pathPrefix + key,
                recursedDeeper
              );

              if (!hasClone) clone[key] = propertyClone;
            }
        }
      }
    }

    return clone;
  }

  return {
    clone: recurse(value, path, new Set()),
    files,
  };
};


/***/ }),

/***/ 13954:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {



const ReactNativeFile = __webpack_require__(86598);

/**
 * Checks if a value is an [extractable file]{@link ExtractableFile}.
 * @kind function
 * @name isExtractableFile
 * @type {ExtractableFileMatcher}
 * @param {*} value Value to check.
 * @returns {boolean} Is the value an [extractable file]{@link ExtractableFile}.
 * @example <caption>Ways to `import`.</caption>
 * ```js
 * import { isExtractableFile } from 'extract-files';
 * ```
 *
 * ```js
 * import isExtractableFile from 'extract-files/public/isExtractableFile.js';
 * ```
 * @example <caption>Ways to `require`.</caption>
 * ```js
 * const { isExtractableFile } = require('extract-files');
 * ```
 *
 * ```js
 * const isExtractableFile = require('extract-files/public/isExtractableFile.js');
 * ```
 */
module.exports = function isExtractableFile(value) {
  return (
    (typeof File !== 'undefined' && value instanceof File) ||
    (typeof Blob !== 'undefined' && value instanceof Blob) ||
    value instanceof ReactNativeFile
  );
};


/***/ }),

/***/ 16898:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZT": function() { return /* binding */ __extends; },
/* harmony export */   "pi": function() { return /* binding */ __assign; }
/* harmony export */ });
/* unused harmony exports __rest, __decorate, __param, __metadata, __awaiter, __generator, __createBinding, __exportStar, __values, __read, __spread, __spreadArrays, __spreadArray, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault, __classPrivateFieldGet, __classPrivateFieldSet, __classPrivateFieldIn */
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}


/***/ }),

/***/ 67558:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* unused harmony exports InvariantError, invariant, setVerbosity */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16898);

var genericMessage = "Invariant Violation";
var _a = Object.setPrototypeOf, setPrototypeOf = _a === void 0 ? function (obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : _a;
var InvariantError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) { message = genericMessage; }
        var _this = _super.call(this, typeof message === "number"
            ? genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)"
            : message) || this;
        _this.framesToPop = 1;
        _this.name = genericMessage;
        setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error));

function invariant(condition, message) {
    if (!condition) {
        throw new InvariantError(message);
    }
}
var verbosityLevels = ["debug", "log", "warn", "error", "silent"];
var verbosityLevel = verbosityLevels.indexOf("log");
function wrapConsoleMethod(name) {
    return function () {
        if (verbosityLevels.indexOf(name) >= verbosityLevel) {
            // Default to console.log if this host environment happens not to provide
            // all the console.* methods we need.
            var method = console[name] || console.log;
            return method.apply(console, arguments);
        }
    };
}
(function (invariant) {
    invariant.debug = wrapConsoleMethod("debug");
    invariant.log = wrapConsoleMethod("log");
    invariant.warn = wrapConsoleMethod("warn");
    invariant.error = wrapConsoleMethod("error");
})(invariant || (invariant = {}));
function setVerbosity(level) {
    var old = verbosityLevels[verbosityLevel];
    verbosityLevel = Math.max(0, verbosityLevels.indexOf(level));
    return old;
}
/* harmony default export */ __webpack_exports__["ZP"] = (invariant);
//# sourceMappingURL=invariant.js.map

/***/ }),

/***/ 449:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BN": function() { return /* binding */ share; },
/* harmony export */   "Hr": function() { return /* binding */ onStart; },
/* harmony export */   "Ld": function() { return /* binding */ subscribe; },
/* harmony export */   "Mq": function() { return /* binding */ onPush; },
/* harmony export */   "Rs": function() { return /* binding */ takeUntil; },
/* harmony export */   "Sy": function() { return /* binding */ make; },
/* harmony export */   "TS": function() { return /* binding */ merge; },
/* harmony export */   "UI": function() { return /* binding */ map; },
/* harmony export */   "Vi": function() { return /* binding */ toPromise; },
/* harmony export */   "_A": function() { return /* binding */ fromValue; },
/* harmony export */   "bw": function() { return /* binding */ onPush; },
/* harmony export */   "hX": function() { return /* binding */ filter; },
/* harmony export */   "nN": function() { return /* binding */ makeSubject; },
/* harmony export */   "nY": function() { return /* binding */ publish; },
/* harmony export */   "oE": function() { return /* binding */ takeWhile; },
/* harmony export */   "ok": function() { return /* binding */ onEnd; },
/* harmony export */   "qn": function() { return /* binding */ take; },
/* harmony export */   "wt": function() { return /* binding */ switchMap; },
/* harmony export */   "zg": function() { return /* binding */ mergeMap; }
/* harmony export */ });
/* unused harmony exports buffer, combine, concat, concatAll, concatMap, debounce, delay, empty, flatten, forEach, fromArray, fromAsyncIterable, fromCallbag, fromDomEvent, fromIterable, fromObservable, fromPromise, interval, lazy, mergeAll, never, pipe, sample, scan, skip, skipUntil, skipWhile, switchAll, takeLast, throttle, toArray, toCallbag, toObservable, zip */
var teardownPlaceholder = () => {};

var e = teardownPlaceholder;

function start(e) {
  var r = [ e ];
  r.tag = 0;
  return r;
}

function push(e) {
  var r = [ e ];
  r.tag = 1;
  return r;
}

var identity = e => e;

function buffer(r) {
  return i => t => {
    var a = [];
    var f = e;
    var n = e;
    var s = !1;
    var l = !1;
    i((e => {
      if (l) {} else if (0 === e) {
        l = !0;
        n(1);
        if (a.length) {
          t(push(a));
        }
        t(0);
      } else if (0 === e.tag) {
        f = e[0];
        r((e => {
          if (l) {} else if (0 === e) {
            l = !0;
            f(1);
            if (a.length) {
              t(push(a));
            }
            t(0);
          } else if (0 === e.tag) {
            n = e[0];
          } else if (a.length) {
            var r = push(a);
            a = [];
            t(r);
          }
        }));
      } else {
        a.push(e[0]);
        if (!s) {
          s = !0;
          f(0);
          n(0);
        } else {
          s = !1;
        }
      }
    }));
    t(start((e => {
      if (1 === e && !l) {
        l = !0;
        f(1);
        n(1);
      } else if (!l && !s) {
        s = !0;
        f(0);
        n(0);
      }
    })));
  };
}

function concatMap(r) {
  return i => t => {
    var a = [];
    var f = e;
    var n = e;
    var s = !1;
    var l = !1;
    var u = !1;
    var o = !1;
    function applyInnerSource(e) {
      u = !0;
      e((e => {
        if (0 === e) {
          if (u) {
            u = !1;
            if (a.length) {
              applyInnerSource(r(a.shift()));
            } else if (o) {
              t(0);
            } else if (!s) {
              s = !0;
              f(0);
            }
          }
        } else if (0 === e.tag) {
          l = !1;
          (n = e[0])(0);
        } else if (u) {
          t(e);
          if (l) {
            l = !1;
          } else {
            n(0);
          }
        }
      }));
    }
    i((e => {
      if (o) {} else if (0 === e) {
        o = !0;
        if (!u && !a.length) {
          t(0);
        }
      } else if (0 === e.tag) {
        f = e[0];
      } else {
        s = !1;
        if (u) {
          a.push(e[0]);
        } else {
          applyInnerSource(r(e[0]));
        }
      }
    }));
    t(start((e => {
      if (1 === e) {
        if (!o) {
          o = !0;
          f(1);
        }
        if (u) {
          u = !1;
          n(1);
        }
      } else {
        if (!o && !s) {
          s = !0;
          f(0);
        }
        if (u && !l) {
          l = !0;
          n(0);
        }
      }
    })));
  };
}

function concatAll(e) {
  return concatMap(identity)(e);
}

function concat(e) {
  return concatAll(r(e));
}

function filter(r) {
  return i => t => {
    var a = e;
    i((e => {
      if (0 === e) {
        t(0);
      } else if (0 === e.tag) {
        a = e[0];
        t(e);
      } else if (!r(e[0])) {
        a(0);
      } else {
        t(e);
      }
    }));
  };
}

function map(e) {
  return r => i => r((r => {
    if (0 === r || 0 === r.tag) {
      i(r);
    } else {
      i(push(e(r[0])));
    }
  }));
}

function mergeMap(r) {
  return i => t => {
    var a = [];
    var f = e;
    var n = !1;
    var s = !1;
    i((i => {
      if (s) {} else if (0 === i) {
        s = !0;
        if (!a.length) {
          t(0);
        }
      } else if (0 === i.tag) {
        f = i[0];
      } else {
        n = !1;
        !function applyInnerSource(r) {
          var i = e;
          r((e => {
            if (0 === e) {
              if (a.length) {
                var r = a.indexOf(i);
                if (r > -1) {
                  (a = a.slice()).splice(r, 1);
                }
                if (!a.length) {
                  if (s) {
                    t(0);
                  } else if (!n) {
                    n = !0;
                    f(0);
                  }
                }
              }
            } else if (0 === e.tag) {
              a.push(i = e[0]);
              i(0);
            } else if (a.length) {
              t(e);
              i(0);
            }
          }));
        }(r(i[0]));
        if (!n) {
          n = !0;
          f(0);
        }
      }
    }));
    t(start((e => {
      if (1 === e) {
        if (!s) {
          s = !0;
          f(1);
        }
        for (var r = 0, i = a, t = a.length; r < t; r++) {
          i[r](1);
        }
        a.length = 0;
      } else {
        if (!s && !n) {
          n = !0;
          f(0);
        } else {
          n = !1;
        }
        for (var l = 0, u = a, o = a.length; l < o; l++) {
          u[l](0);
        }
      }
    })));
  };
}

function mergeAll(e) {
  return mergeMap(identity)(e);
}

function merge(e) {
  return mergeAll(r(e));
}

function onEnd(e) {
  return r => i => {
    var t = !1;
    r((r => {
      if (t) {} else if (0 === r) {
        t = !0;
        i(0);
        e();
      } else if (0 === r.tag) {
        var a = r[0];
        i(start((r => {
          if (1 === r) {
            t = !0;
            a(1);
            e();
          } else {
            a(r);
          }
        })));
      } else {
        i(r);
      }
    }));
  };
}

function onPush(e) {
  return r => i => {
    var t = !1;
    r((r => {
      if (t) {} else if (0 === r) {
        t = !0;
        i(0);
      } else if (0 === r.tag) {
        var a = r[0];
        i(start((e => {
          if (1 === e) {
            t = !0;
          }
          a(e);
        })));
      } else {
        e(r[0]);
        i(r);
      }
    }));
  };
}

function onStart(e) {
  return r => i => r((r => {
    if (0 === r) {
      i(0);
    } else if (0 === r.tag) {
      i(r);
      e();
    } else {
      i(r);
    }
  }));
}

function sample(r) {
  return i => t => {
    var a = e;
    var f = e;
    var n;
    var s = !1;
    var l = !1;
    i((e => {
      if (l) {} else if (0 === e) {
        l = !0;
        f(1);
        t(0);
      } else if (0 === e.tag) {
        a = e[0];
      } else {
        n = e[0];
        if (!s) {
          s = !0;
          f(0);
          a(0);
        } else {
          s = !1;
        }
      }
    }));
    r((e => {
      if (l) {} else if (0 === e) {
        l = !0;
        a(1);
        t(0);
      } else if (0 === e.tag) {
        f = e[0];
      } else if (void 0 !== n) {
        var r = push(n);
        n = void 0;
        t(r);
      }
    }));
    t(start((e => {
      if (1 === e && !l) {
        l = !0;
        a(1);
        f(1);
      } else if (!l && !s) {
        s = !0;
        a(0);
        f(0);
      }
    })));
  };
}

function scan(e, r) {
  return i => t => {
    var a = r;
    i((r => {
      if (0 === r) {
        t(0);
      } else if (0 === r.tag) {
        t(r);
      } else {
        t(push(a = e(a, r[0])));
      }
    }));
  };
}

function share(r) {
  var i = [];
  var t = e;
  var a = !1;
  return e => {
    i.push(e);
    if (1 === i.length) {
      r((e => {
        if (0 === e) {
          for (var r = 0, f = i, n = i.length; r < n; r++) {
            f[r](0);
          }
          i.length = 0;
        } else if (0 === e.tag) {
          t = e[0];
        } else {
          a = !1;
          for (var s = 0, l = i, u = i.length; s < u; s++) {
            l[s](e);
          }
        }
      }));
    }
    e(start((r => {
      if (1 === r) {
        var f = i.indexOf(e);
        if (f > -1) {
          (i = i.slice()).splice(f, 1);
        }
        if (!i.length) {
          t(1);
        }
      } else if (!a) {
        a = !0;
        t(0);
      }
    })));
  };
}

function skip(r) {
  return i => t => {
    var a = e;
    var f = r;
    i((e => {
      if (0 === e) {
        t(0);
      } else if (0 === e.tag) {
        a = e[0];
        t(e);
      } else if (f-- > 0) {
        a(0);
      } else {
        t(e);
      }
    }));
  };
}

function skipUntil(r) {
  return i => t => {
    var a = e;
    var f = e;
    var n = !0;
    var s = !1;
    var l = !1;
    i((e => {
      if (l) {} else if (0 === e) {
        l = !0;
        if (n) {
          f(1);
        }
        t(0);
      } else if (0 === e.tag) {
        a = e[0];
        r((e => {
          if (0 === e) {
            if (n) {
              l = !0;
              a(1);
            }
          } else if (0 === e.tag) {
            (f = e[0])(0);
          } else {
            n = !1;
            f(1);
          }
        }));
      } else if (!n) {
        s = !1;
        t(e);
      } else if (!s) {
        s = !0;
        a(0);
        f(0);
      } else {
        s = !1;
      }
    }));
    t(start((e => {
      if (1 === e && !l) {
        l = !0;
        a(1);
        if (n) {
          f(1);
        }
      } else if (!l && !s) {
        s = !0;
        if (n) {
          f(0);
        }
        a(0);
      }
    })));
  };
}

function skipWhile(r) {
  return i => t => {
    var a = e;
    var f = !0;
    i((e => {
      if (0 === e) {
        t(0);
      } else if (0 === e.tag) {
        a = e[0];
        t(e);
      } else if (f) {
        if (r(e[0])) {
          a(0);
        } else {
          f = !1;
          t(e);
        }
      } else {
        t(e);
      }
    }));
  };
}

function switchMap(r) {
  return i => t => {
    var a = e;
    var f = e;
    var n = !1;
    var s = !1;
    var l = !1;
    var u = !1;
    i((i => {
      if (u) {} else if (0 === i) {
        u = !0;
        if (!l) {
          t(0);
        }
      } else if (0 === i.tag) {
        a = i[0];
      } else {
        if (l) {
          f(1);
          f = e;
        }
        if (!n) {
          n = !0;
          a(0);
        } else {
          n = !1;
        }
        !function applyInnerSource(e) {
          l = !0;
          e((e => {
            if (!l) {} else if (0 === e) {
              l = !1;
              if (u) {
                t(0);
              } else if (!n) {
                n = !0;
                a(0);
              }
            } else if (0 === e.tag) {
              s = !1;
              (f = e[0])(0);
            } else {
              t(e);
              if (!s) {
                f(0);
              } else {
                s = !1;
              }
            }
          }));
        }(r(i[0]));
      }
    }));
    t(start((e => {
      if (1 === e) {
        if (!u) {
          u = !0;
          a(1);
        }
        if (l) {
          l = !1;
          f(1);
        }
      } else {
        if (!u && !n) {
          n = !0;
          a(0);
        }
        if (l && !s) {
          s = !0;
          f(0);
        }
      }
    })));
  };
}

function switchAll(e) {
  return switchMap(identity)(e);
}

function take(r) {
  return i => t => {
    var a = e;
    var f = !1;
    var n = 0;
    i((e => {
      if (f) {} else if (0 === e) {
        f = !0;
        t(0);
      } else if (0 === e.tag) {
        if (r <= 0) {
          f = !0;
          t(0);
          e[0](1);
        } else {
          a = e[0];
        }
      } else if (n++ < r) {
        t(e);
        if (!f && n >= r) {
          f = !0;
          t(0);
          a(1);
        }
      } else {
        t(e);
      }
    }));
    t(start((e => {
      if (1 === e && !f) {
        f = !0;
        a(1);
      } else if (0 === e && !f && n < r) {
        a(0);
      }
    })));
  };
}

function takeLast(i) {
  return t => a => {
    var f = [];
    var n = e;
    t((e => {
      if (0 === e) {
        r(f)(a);
      } else if (0 === e.tag) {
        if (i <= 0) {
          e[0](1);
          r(f)(a);
        } else {
          (n = e[0])(0);
        }
      } else {
        if (f.length >= i && i) {
          f.shift();
        }
        f.push(e[0]);
        n(0);
      }
    }));
  };
}

function takeUntil(r) {
  return i => t => {
    var a = e;
    var f = e;
    var n = !1;
    i((e => {
      if (n) {} else if (0 === e) {
        n = !0;
        f(1);
        t(0);
      } else if (0 === e.tag) {
        a = e[0];
        r((e => {
          if (0 === e) {} else if (0 === e.tag) {
            (f = e[0])(0);
          } else {
            n = !0;
            a(1);
            t(0);
          }
        }));
      } else {
        t(e);
      }
    }));
    t(start((e => {
      if (1 === e && !n) {
        n = !0;
        a(1);
        f(1);
      } else if (!n) {
        a(0);
      }
    })));
  };
}

function takeWhile(r) {
  return i => t => {
    var a = e;
    var f = !1;
    i((e => {
      if (f) {} else if (0 === e) {
        f = !0;
        t(0);
      } else if (0 === e.tag) {
        a = e[0];
        t(e);
      } else if (!r(e[0])) {
        f = !0;
        t(0);
        a(1);
      } else {
        t(e);
      }
    }));
  };
}

function debounce(e) {
  return r => i => {
    var t;
    var a = !1;
    var f = !1;
    r((r => {
      if (f) {} else if (0 === r) {
        f = !0;
        if (t) {
          a = !0;
        } else {
          i(0);
        }
      } else if (0 === r.tag) {
        var n = r[0];
        i(start((e => {
          if (1 === e && !f) {
            f = !0;
            a = !1;
            if (t) {
              clearTimeout(t);
            }
            n(1);
          } else if (!f) {
            n(0);
          }
        })));
      } else {
        if (t) {
          clearTimeout(t);
        }
        t = setTimeout((() => {
          t = void 0;
          i(r);
          if (a) {
            i(0);
          }
        }), e(r[0]));
      }
    }));
  };
}

function delay(e) {
  return r => i => {
    var t = 0;
    r((r => {
      if (0 !== r && 0 === r.tag) {
        i(r);
      } else {
        t++;
        setTimeout((() => {
          if (t) {
            t--;
            i(r);
          }
        }), e);
      }
    }));
  };
}

function throttle(e) {
  return r => i => {
    var t = !1;
    var a;
    r((r => {
      if (0 === r) {
        if (a) {
          clearTimeout(a);
        }
        i(0);
      } else if (0 === r.tag) {
        var f = r[0];
        i(start((e => {
          if (1 === e) {
            if (a) {
              clearTimeout(a);
            }
            f(1);
          } else {
            f(0);
          }
        })));
      } else if (!t) {
        t = !0;
        if (a) {
          clearTimeout(a);
        }
        a = setTimeout((() => {
          a = void 0;
          t = !1;
        }), e(r[0]));
        i(r);
      }
    }));
  };
}

function lazy(e) {
  return r => e()(r);
}

function fromAsyncIterable(e) {
  return r => {
    var i = e[Symbol.asyncIterator]();
    var t = !1;
    var a = !1;
    var f = !1;
    var n;
    r(start((async e => {
      if (1 === e) {
        t = !0;
        if (i.return) {
          i.return();
        }
      } else if (a) {
        f = !0;
      } else {
        for (f = a = !0; f && !t; ) {
          if ((n = await i.next()).done) {
            t = !0;
            if (i.return) {
              await i.return();
            }
            r(0);
          } else {
            try {
              f = !1;
              r(push(n.value));
            } catch (e) {
              if (i.throw) {
                if (t = !!(await i.throw(e)).done) {
                  r(0);
                }
              } else {
                throw e;
              }
            }
          }
        }
        a = !1;
      }
    })));
  };
}

function fromIterable(e) {
  if (e[Symbol.asyncIterator]) {
    return fromAsyncIterable(e);
  }
  return r => {
    var i = e[Symbol.iterator]();
    var t = !1;
    var a = !1;
    var f = !1;
    var n;
    r(start((e => {
      if (1 === e) {
        t = !0;
        if (i.return) {
          i.return();
        }
      } else if (a) {
        f = !0;
      } else {
        for (f = a = !0; f && !t; ) {
          if ((n = i.next()).done) {
            t = !0;
            if (i.return) {
              i.return();
            }
            r(0);
          } else {
            try {
              f = !1;
              r(push(n.value));
            } catch (e) {
              if (i.throw) {
                if (t = !!i.throw(e).done) {
                  r(0);
                }
              } else {
                throw e;
              }
            }
          }
        }
        a = !1;
      }
    })));
  };
}

var r = fromIterable;

function fromValue(e) {
  return r => {
    var i = !1;
    r(start((t => {
      if (1 === t) {
        i = !0;
      } else if (!i) {
        i = !0;
        r(push(e));
        r(0);
      }
    })));
  };
}

function make(e) {
  return r => {
    var i = !1;
    var t = e({
      next(e) {
        if (!i) {
          r(push(e));
        }
      },
      complete() {
        if (!i) {
          i = !0;
          r(0);
        }
      }
    });
    r(start((e => {
      if (1 === e && !i) {
        i = !0;
        t();
      }
    })));
  };
}

function makeSubject() {
  var e;
  var r;
  return {
    source: share(make((i => {
      e = i.next;
      r = i.complete;
      return teardownPlaceholder;
    }))),
    next(r) {
      if (e) {
        e(r);
      }
    },
    complete() {
      if (r) {
        r();
      }
    }
  };
}

var empty = e => {
  var r = !1;
  e(start((i => {
    if (1 === i) {
      r = !0;
    } else if (!r) {
      r = !0;
      e(0);
    }
  })));
};

var never = r => {
  r(start(e));
};

function interval(e) {
  return make((r => {
    var i = 0;
    var t = setInterval((() => r.next(i++)), e);
    return () => clearInterval(t);
  }));
}

function fromDomEvent(e, r) {
  return make((i => {
    e.addEventListener(r, i.next);
    return () => e.removeEventListener(r, i.next);
  }));
}

function fromPromise(e) {
  return make((r => {
    e.then((e => {
      Promise.resolve(e).then((() => {
        r.next(e);
        r.complete();
      }));
    }));
    return teardownPlaceholder;
  }));
}

function subscribe(r) {
  return i => {
    var t = e;
    var a = !1;
    i((e => {
      if (0 === e) {
        a = !0;
      } else if (0 === e.tag) {
        (t = e[0])(0);
      } else if (!a) {
        r(e[0]);
        t(0);
      }
    }));
    return {
      unsubscribe() {
        if (!a) {
          a = !0;
          t(1);
        }
      }
    };
  };
}

function forEach(e) {
  return r => {
    subscribe(e)(r);
  };
}

function publish(e) {
  subscribe((e => {}))(e);
}

function toArray(r) {
  var i = [];
  var t = e;
  var a = !1;
  r((e => {
    if (0 === e) {
      a = !0;
    } else if (0 === e.tag) {
      (t = e[0])(0);
    } else {
      i.push(e[0]);
      t(0);
    }
  }));
  if (!a) {
    t(1);
  }
  return i;
}

function toPromise(r) {
  return new Promise((i => {
    var t = e;
    var a;
    r((e => {
      if (0 === e) {
        i(a);
      } else if (0 === e.tag) {
        (t = e[0])(0);
      } else {
        a = e[0];
        t(0);
      }
    }));
  }));
}

function zip(r) {
  var i = Object.keys(r).length;
  return t => {
    var a = new Set;
    var f = Array.isArray(r) ? new Array(i).fill(e) : {};
    var n = Array.isArray(r) ? new Array(i) : {};
    var s = !1;
    var l = !1;
    var u = !1;
    var o = 0;
    var loop = function(v) {
      r[v]((c => {
        if (0 === c) {
          if (o >= i - 1) {
            u = !0;
            t(0);
          } else {
            o++;
          }
        } else if (0 === c.tag) {
          f[v] = c[0];
        } else if (!u) {
          n[v] = c[0];
          a.add(v);
          if (!s && a.size < i) {
            if (!l) {
              for (var h in r) {
                if (!a.has(h)) {
                  (f[h] || e)(0);
                }
              }
            } else {
              l = !1;
            }
          } else {
            s = !0;
            l = !1;
            t(push(Array.isArray(n) ? n.slice() : {
              ...n
            }));
          }
        }
      }));
    };
    for (var v in r) {
      loop(v);
    }
    t(start((e => {
      if (u) {} else if (1 === e) {
        u = !0;
        for (var r in f) {
          f[r](1);
        }
      } else if (!l) {
        l = !0;
        for (var i in f) {
          f[i](0);
        }
      }
    })));
  };
}

function combine(...e) {
  return zip(e);
}

var observableSymbol = () => Symbol.observable || (Symbol.observable = Symbol("observable"));

function fromObservable(e) {
  e = e[observableSymbol()] ? e[observableSymbol()]() : e;
  return r => {
    var i = e.subscribe({
      next(e) {
        r(push(e));
      },
      complete() {
        r(0);
      },
      error() {}
    });
    r(start((e => {
      if (1 === e) {
        i.unsubscribe();
      }
    })));
  };
}

function toObservable(r) {
  return {
    subscribe(i) {
      var t = e;
      var a = !1;
      r((e => {
        if (a) {} else if (0 === e) {
          a = !0;
          i.complete();
        } else if (0 === e.tag) {
          (t = e[0])(0);
        } else {
          i.next(e[0]);
          t(0);
        }
      }));
      var f = {
        closed: !1,
        unsubscribe() {
          f.closed = !0;
          a = !0;
          t(1);
        }
      };
      return f;
    },
    [observableSymbol()]() {
      return this;
    }
  };
}

function fromCallbag(e) {
  return r => {
    e(0, ((e, i) => {
      if (0 === e) {
        r(start((e => {
          i(e + 1);
        })));
      } else if (1 === e) {
        r(push(i));
      } else {
        r(0);
      }
    }));
  };
}

function toCallbag(e) {
  return (r, i) => {
    if (0 === r) {
      e((e => {
        if (0 === e) {
          i(2);
        } else if (0 === e.tag) {
          i(0, (r => {
            if (r < 3) {
              e[0](r - 1);
            }
          }));
        } else {
          i(1, e[0]);
        }
      }));
    }
  };
}

function pipe(...e) {
  var r = e[0];
  for (var i = 1, t = e.length; i < t; i++) {
    r = e[i](r);
  }
  return r;
}


//# sourceMappingURL=wonka.mjs.map


/***/ }),

/***/ 79647:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BN": function() { return /* binding */ share; },
/* harmony export */   "Hr": function() { return /* binding */ onStart; },
/* harmony export */   "Mq": function() { return /* binding */ onPush; },
/* harmony export */   "Rs": function() { return /* binding */ takeUntil; },
/* harmony export */   "TS": function() { return /* binding */ merge; },
/* harmony export */   "UI": function() { return /* binding */ map; },
/* harmony export */   "Vi": function() { return /* binding */ toPromise; },
/* harmony export */   "_A": function() { return /* binding */ fromValue; },
/* harmony export */   "cS": function() { return /* binding */ empty; },
/* harmony export */   "hX": function() { return /* binding */ filter; },
/* harmony export */   "nN": function() { return /* binding */ makeSubject; },
/* harmony export */   "p4": function() { return /* binding */ fromPromise; },
/* harmony export */   "qn": function() { return /* binding */ take; },
/* harmony export */   "zg": function() { return /* binding */ mergeMap; }
/* harmony export */ });
/* unused harmony exports buffer, combine, concat, concatAll, concatMap, debounce, delay, flatten, forEach, fromArray, fromAsyncIterable, fromCallbag, fromDomEvent, fromIterable, fromObservable, interval, lazy, make, mergeAll, never, onEnd, pipe, publish, sample, scan, skip, skipUntil, skipWhile, subscribe, switchAll, switchMap, takeLast, takeWhile, tap, throttle, toArray, toCallbag, toObservable, zip */
var teardownPlaceholder = () => {};

var e = teardownPlaceholder;

function start(e) {
  var r = [ e ];
  r.tag = 0;
  return r;
}

function push(e) {
  var r = [ e ];
  r.tag = 1;
  return r;
}

var identity = e => e;

function buffer(r) {
  return i => t => {
    var a = [];
    var f = e;
    var n = e;
    var s = !1;
    var l = !1;
    i((e => {
      if (l) {} else if (0 === e) {
        l = !0;
        n(1);
        if (a.length) {
          t(push(a));
        }
        t(0);
      } else if (0 === e.tag) {
        f = e[0];
        r((e => {
          if (l) {} else if (0 === e) {
            l = !0;
            f(1);
            if (a.length) {
              t(push(a));
            }
            t(0);
          } else if (0 === e.tag) {
            n = e[0];
          } else if (a.length) {
            var r = push(a);
            a = [];
            t(r);
          }
        }));
      } else {
        a.push(e[0]);
        if (!s) {
          s = !0;
          f(0);
          n(0);
        } else {
          s = !1;
        }
      }
    }));
    t(start((e => {
      if (1 === e && !l) {
        l = !0;
        f(1);
        n(1);
      } else if (!l && !s) {
        s = !0;
        f(0);
        n(0);
      }
    })));
  };
}

function concatMap(r) {
  return i => t => {
    var a = [];
    var f = e;
    var n = e;
    var s = !1;
    var l = !1;
    var u = !1;
    var o = !1;
    function applyInnerSource(e) {
      u = !0;
      e((e => {
        if (0 === e) {
          if (u) {
            u = !1;
            if (a.length) {
              applyInnerSource(r(a.shift()));
            } else if (o) {
              t(0);
            } else if (!s) {
              s = !0;
              f(0);
            }
          }
        } else if (0 === e.tag) {
          l = !1;
          (n = e[0])(0);
        } else if (u) {
          t(e);
          if (l) {
            l = !1;
          } else {
            n(0);
          }
        }
      }));
    }
    i((e => {
      if (o) {} else if (0 === e) {
        o = !0;
        if (!u && !a.length) {
          t(0);
        }
      } else if (0 === e.tag) {
        f = e[0];
      } else {
        s = !1;
        if (u) {
          a.push(e[0]);
        } else {
          applyInnerSource(r(e[0]));
        }
      }
    }));
    t(start((e => {
      if (1 === e) {
        if (!o) {
          o = !0;
          f(1);
        }
        if (u) {
          u = !1;
          n(1);
        }
      } else {
        if (!o && !s) {
          s = !0;
          f(0);
        }
        if (u && !l) {
          l = !0;
          n(0);
        }
      }
    })));
  };
}

function concatAll(e) {
  return concatMap(identity)(e);
}

function concat(e) {
  return concatAll(r(e));
}

function filter(r) {
  return i => t => {
    var a = e;
    i((e => {
      if (0 === e) {
        t(0);
      } else if (0 === e.tag) {
        a = e[0];
        t(e);
      } else if (!r(e[0])) {
        a(0);
      } else {
        t(e);
      }
    }));
  };
}

function map(e) {
  return r => i => r((r => {
    if (0 === r || 0 === r.tag) {
      i(r);
    } else {
      i(push(e(r[0])));
    }
  }));
}

function mergeMap(r) {
  return i => t => {
    var a = [];
    var f = e;
    var n = !1;
    var s = !1;
    i((i => {
      if (s) {} else if (0 === i) {
        s = !0;
        if (!a.length) {
          t(0);
        }
      } else if (0 === i.tag) {
        f = i[0];
      } else {
        n = !1;
        !function applyInnerSource(r) {
          var i = e;
          r((e => {
            if (0 === e) {
              if (a.length) {
                var r = a.indexOf(i);
                if (r > -1) {
                  (a = a.slice()).splice(r, 1);
                }
                if (!a.length) {
                  if (s) {
                    t(0);
                  } else if (!n) {
                    n = !0;
                    f(0);
                  }
                }
              }
            } else if (0 === e.tag) {
              a.push(i = e[0]);
              i(0);
            } else if (a.length) {
              t(e);
              i(0);
            }
          }));
        }(r(i[0]));
        if (!n) {
          n = !0;
          f(0);
        }
      }
    }));
    t(start((e => {
      if (1 === e) {
        if (!s) {
          s = !0;
          f(1);
        }
        for (var r = 0, i = a, t = a.length; r < t; r++) {
          i[r](1);
        }
        a.length = 0;
      } else {
        if (!s && !n) {
          n = !0;
          f(0);
        } else {
          n = !1;
        }
        for (var l = 0, u = a, o = a.length; l < o; l++) {
          u[l](0);
        }
      }
    })));
  };
}

function mergeAll(e) {
  return mergeMap(identity)(e);
}

function merge(e) {
  return mergeAll(r(e));
}

function onEnd(e) {
  return r => i => {
    var t = !1;
    r((r => {
      if (t) {} else if (0 === r) {
        t = !0;
        i(0);
        e();
      } else if (0 === r.tag) {
        var a = r[0];
        i(start((r => {
          if (1 === r) {
            t = !0;
            a(1);
            e();
          } else {
            a(r);
          }
        })));
      } else {
        i(r);
      }
    }));
  };
}

function onPush(e) {
  return r => i => {
    var t = !1;
    r((r => {
      if (t) {} else if (0 === r) {
        t = !0;
        i(0);
      } else if (0 === r.tag) {
        var a = r[0];
        i(start((e => {
          if (1 === e) {
            t = !0;
          }
          a(e);
        })));
      } else {
        e(r[0]);
        i(r);
      }
    }));
  };
}

function onStart(e) {
  return r => i => r((r => {
    if (0 === r) {
      i(0);
    } else if (0 === r.tag) {
      i(r);
      e();
    } else {
      i(r);
    }
  }));
}

function sample(r) {
  return i => t => {
    var a = e;
    var f = e;
    var n;
    var s = !1;
    var l = !1;
    i((e => {
      if (l) {} else if (0 === e) {
        l = !0;
        f(1);
        t(0);
      } else if (0 === e.tag) {
        a = e[0];
      } else {
        n = e[0];
        if (!s) {
          s = !0;
          f(0);
          a(0);
        } else {
          s = !1;
        }
      }
    }));
    r((e => {
      if (l) {} else if (0 === e) {
        l = !0;
        a(1);
        t(0);
      } else if (0 === e.tag) {
        f = e[0];
      } else if (void 0 !== n) {
        var r = push(n);
        n = void 0;
        t(r);
      }
    }));
    t(start((e => {
      if (1 === e && !l) {
        l = !0;
        a(1);
        f(1);
      } else if (!l && !s) {
        s = !0;
        a(0);
        f(0);
      }
    })));
  };
}

function scan(e, r) {
  return i => t => {
    var a = r;
    i((r => {
      if (0 === r) {
        t(0);
      } else if (0 === r.tag) {
        t(r);
      } else {
        t(push(a = e(a, r[0])));
      }
    }));
  };
}

function share(r) {
  var i = [];
  var t = e;
  var a = !1;
  return e => {
    i.push(e);
    if (1 === i.length) {
      r((e => {
        if (0 === e) {
          for (var r = 0, f = i, n = i.length; r < n; r++) {
            f[r](0);
          }
          i.length = 0;
        } else if (0 === e.tag) {
          t = e[0];
        } else {
          a = !1;
          for (var s = 0, l = i, u = i.length; s < u; s++) {
            l[s](e);
          }
        }
      }));
    }
    e(start((r => {
      if (1 === r) {
        var f = i.indexOf(e);
        if (f > -1) {
          (i = i.slice()).splice(f, 1);
        }
        if (!i.length) {
          t(1);
        }
      } else if (!a) {
        a = !0;
        t(0);
      }
    })));
  };
}

function skip(r) {
  return i => t => {
    var a = e;
    var f = r;
    i((e => {
      if (0 === e) {
        t(0);
      } else if (0 === e.tag) {
        a = e[0];
        t(e);
      } else if (f-- > 0) {
        a(0);
      } else {
        t(e);
      }
    }));
  };
}

function skipUntil(r) {
  return i => t => {
    var a = e;
    var f = e;
    var n = !0;
    var s = !1;
    var l = !1;
    i((e => {
      if (l) {} else if (0 === e) {
        l = !0;
        if (n) {
          f(1);
        }
        t(0);
      } else if (0 === e.tag) {
        a = e[0];
        r((e => {
          if (0 === e) {
            if (n) {
              l = !0;
              a(1);
            }
          } else if (0 === e.tag) {
            (f = e[0])(0);
          } else {
            n = !1;
            f(1);
          }
        }));
      } else if (!n) {
        s = !1;
        t(e);
      } else if (!s) {
        s = !0;
        a(0);
        f(0);
      } else {
        s = !1;
      }
    }));
    t(start((e => {
      if (1 === e && !l) {
        l = !0;
        a(1);
        if (n) {
          f(1);
        }
      } else if (!l && !s) {
        s = !0;
        if (n) {
          f(0);
        }
        a(0);
      }
    })));
  };
}

function skipWhile(r) {
  return i => t => {
    var a = e;
    var f = !0;
    i((e => {
      if (0 === e) {
        t(0);
      } else if (0 === e.tag) {
        a = e[0];
        t(e);
      } else if (f) {
        if (r(e[0])) {
          a(0);
        } else {
          f = !1;
          t(e);
        }
      } else {
        t(e);
      }
    }));
  };
}

function switchMap(r) {
  return i => t => {
    var a = e;
    var f = e;
    var n = !1;
    var s = !1;
    var l = !1;
    var u = !1;
    i((i => {
      if (u) {} else if (0 === i) {
        u = !0;
        if (!l) {
          t(0);
        }
      } else if (0 === i.tag) {
        a = i[0];
      } else {
        if (l) {
          f(1);
          f = e;
        }
        if (!n) {
          n = !0;
          a(0);
        } else {
          n = !1;
        }
        !function applyInnerSource(e) {
          l = !0;
          e((e => {
            if (!l) {} else if (0 === e) {
              l = !1;
              if (u) {
                t(0);
              } else if (!n) {
                n = !0;
                a(0);
              }
            } else if (0 === e.tag) {
              s = !1;
              (f = e[0])(0);
            } else {
              t(e);
              if (!s) {
                f(0);
              } else {
                s = !1;
              }
            }
          }));
        }(r(i[0]));
      }
    }));
    t(start((e => {
      if (1 === e) {
        if (!u) {
          u = !0;
          a(1);
        }
        if (l) {
          l = !1;
          f(1);
        }
      } else {
        if (!u && !n) {
          n = !0;
          a(0);
        }
        if (l && !s) {
          s = !0;
          f(0);
        }
      }
    })));
  };
}

function switchAll(e) {
  return switchMap(identity)(e);
}

function take(r) {
  return i => t => {
    var a = e;
    var f = !1;
    var n = 0;
    i((e => {
      if (f) {} else if (0 === e) {
        f = !0;
        t(0);
      } else if (0 === e.tag) {
        if (r <= 0) {
          f = !0;
          t(0);
          e[0](1);
        } else {
          a = e[0];
        }
      } else if (n++ < r) {
        t(e);
        if (!f && n >= r) {
          f = !0;
          t(0);
          a(1);
        }
      } else {
        t(e);
      }
    }));
    t(start((e => {
      if (1 === e && !f) {
        f = !0;
        a(1);
      } else if (0 === e && !f && n < r) {
        a(0);
      }
    })));
  };
}

function takeLast(i) {
  return t => a => {
    var f = [];
    var n = e;
    t((e => {
      if (0 === e) {
        r(f)(a);
      } else if (0 === e.tag) {
        if (i <= 0) {
          e[0](1);
          r(f)(a);
        } else {
          (n = e[0])(0);
        }
      } else {
        if (f.length >= i && i) {
          f.shift();
        }
        f.push(e[0]);
        n(0);
      }
    }));
  };
}

function takeUntil(r) {
  return i => t => {
    var a = e;
    var f = e;
    var n = !1;
    i((e => {
      if (n) {} else if (0 === e) {
        n = !0;
        f(1);
        t(0);
      } else if (0 === e.tag) {
        a = e[0];
        r((e => {
          if (0 === e) {} else if (0 === e.tag) {
            (f = e[0])(0);
          } else {
            n = !0;
            a(1);
            t(0);
          }
        }));
      } else {
        t(e);
      }
    }));
    t(start((e => {
      if (1 === e && !n) {
        n = !0;
        a(1);
        f(1);
      } else if (!n) {
        a(0);
      }
    })));
  };
}

function takeWhile(r) {
  return i => t => {
    var a = e;
    var f = !1;
    i((e => {
      if (f) {} else if (0 === e) {
        f = !0;
        t(0);
      } else if (0 === e.tag) {
        a = e[0];
        t(e);
      } else if (!r(e[0])) {
        f = !0;
        t(0);
        a(1);
      } else {
        t(e);
      }
    }));
  };
}

function debounce(e) {
  return r => i => {
    var t;
    var a = !1;
    var f = !1;
    r((r => {
      if (f) {} else if (0 === r) {
        f = !0;
        if (t) {
          a = !0;
        } else {
          i(0);
        }
      } else if (0 === r.tag) {
        var n = r[0];
        i(start((e => {
          if (1 === e && !f) {
            f = !0;
            a = !1;
            if (t) {
              clearTimeout(t);
            }
            n(1);
          } else if (!f) {
            n(0);
          }
        })));
      } else {
        if (t) {
          clearTimeout(t);
        }
        t = setTimeout((() => {
          t = void 0;
          i(r);
          if (a) {
            i(0);
          }
        }), e(r[0]));
      }
    }));
  };
}

function delay(e) {
  return r => i => {
    var t = 0;
    r((r => {
      if (0 !== r && 0 === r.tag) {
        i(r);
      } else {
        t++;
        setTimeout((() => {
          if (t) {
            t--;
            i(r);
          }
        }), e);
      }
    }));
  };
}

function throttle(e) {
  return r => i => {
    var t = !1;
    var a;
    r((r => {
      if (0 === r) {
        if (a) {
          clearTimeout(a);
        }
        i(0);
      } else if (0 === r.tag) {
        var f = r[0];
        i(start((e => {
          if (1 === e) {
            if (a) {
              clearTimeout(a);
            }
            f(1);
          } else {
            f(0);
          }
        })));
      } else if (!t) {
        t = !0;
        if (a) {
          clearTimeout(a);
        }
        a = setTimeout((() => {
          a = void 0;
          t = !1;
        }), e(r[0]));
        i(r);
      }
    }));
  };
}

function lazy(e) {
  return r => e()(r);
}

function fromAsyncIterable(e) {
  return r => {
    var i = e[Symbol.asyncIterator]();
    var t = !1;
    var a = !1;
    var f = !1;
    var n;
    r(start((async e => {
      if (1 === e) {
        t = !0;
        if (i.return) {
          i.return();
        }
      } else if (a) {
        f = !0;
      } else {
        for (f = a = !0; f && !t; ) {
          if ((n = await i.next()).done) {
            t = !0;
            if (i.return) {
              await i.return();
            }
            r(0);
          } else {
            try {
              f = !1;
              r(push(n.value));
            } catch (e) {
              if (i.throw) {
                if (t = !!(await i.throw(e)).done) {
                  r(0);
                }
              } else {
                throw e;
              }
            }
          }
        }
        a = !1;
      }
    })));
  };
}

function fromIterable(e) {
  if (e[Symbol.asyncIterator]) {
    return fromAsyncIterable(e);
  }
  return r => {
    var i = e[Symbol.iterator]();
    var t = !1;
    var a = !1;
    var f = !1;
    var n;
    r(start((e => {
      if (1 === e) {
        t = !0;
        if (i.return) {
          i.return();
        }
      } else if (a) {
        f = !0;
      } else {
        for (f = a = !0; f && !t; ) {
          if ((n = i.next()).done) {
            t = !0;
            if (i.return) {
              i.return();
            }
            r(0);
          } else {
            try {
              f = !1;
              r(push(n.value));
            } catch (e) {
              if (i.throw) {
                if (t = !!i.throw(e).done) {
                  r(0);
                }
              } else {
                throw e;
              }
            }
          }
        }
        a = !1;
      }
    })));
  };
}

var r = fromIterable;

function fromValue(e) {
  return r => {
    var i = !1;
    r(start((t => {
      if (1 === t) {
        i = !0;
      } else if (!i) {
        i = !0;
        r(push(e));
        r(0);
      }
    })));
  };
}

function make(e) {
  return r => {
    var i = !1;
    var t = e({
      next(e) {
        if (!i) {
          r(push(e));
        }
      },
      complete() {
        if (!i) {
          i = !0;
          r(0);
        }
      }
    });
    r(start((e => {
      if (1 === e && !i) {
        i = !0;
        t();
      }
    })));
  };
}

function makeSubject() {
  var e;
  var r;
  return {
    source: share(make((i => {
      e = i.next;
      r = i.complete;
      return teardownPlaceholder;
    }))),
    next(r) {
      if (e) {
        e(r);
      }
    },
    complete() {
      if (r) {
        r();
      }
    }
  };
}

var empty = e => {
  var r = !1;
  e(start((i => {
    if (1 === i) {
      r = !0;
    } else if (!r) {
      r = !0;
      e(0);
    }
  })));
};

var never = r => {
  r(start(e));
};

function interval(e) {
  return make((r => {
    var i = 0;
    var t = setInterval((() => r.next(i++)), e);
    return () => clearInterval(t);
  }));
}

function fromDomEvent(e, r) {
  return make((i => {
    e.addEventListener(r, i.next);
    return () => e.removeEventListener(r, i.next);
  }));
}

function fromPromise(e) {
  return make((r => {
    e.then((e => {
      Promise.resolve(e).then((() => {
        r.next(e);
        r.complete();
      }));
    }));
    return teardownPlaceholder;
  }));
}

function subscribe(r) {
  return i => {
    var t = e;
    var a = !1;
    i((e => {
      if (0 === e) {
        a = !0;
      } else if (0 === e.tag) {
        (t = e[0])(0);
      } else if (!a) {
        r(e[0]);
        t(0);
      }
    }));
    return {
      unsubscribe() {
        if (!a) {
          a = !0;
          t(1);
        }
      }
    };
  };
}

function forEach(e) {
  return r => {
    subscribe(e)(r);
  };
}

function publish(e) {
  subscribe((e => {}))(e);
}

function toArray(r) {
  var i = [];
  var t = e;
  var a = !1;
  r((e => {
    if (0 === e) {
      a = !0;
    } else if (0 === e.tag) {
      (t = e[0])(0);
    } else {
      i.push(e[0]);
      t(0);
    }
  }));
  if (!a) {
    t(1);
  }
  return i;
}

function toPromise(r) {
  return new Promise((i => {
    var t = e;
    var a;
    r((e => {
      if (0 === e) {
        i(a);
      } else if (0 === e.tag) {
        (t = e[0])(0);
      } else {
        a = e[0];
        t(0);
      }
    }));
  }));
}

function zip(r) {
  var i = Object.keys(r).length;
  return t => {
    var a = new Set;
    var f = Array.isArray(r) ? new Array(i).fill(e) : {};
    var n = Array.isArray(r) ? new Array(i) : {};
    var s = !1;
    var l = !1;
    var u = !1;
    var o = 0;
    var loop = function(v) {
      r[v]((c => {
        if (0 === c) {
          if (o >= i - 1) {
            u = !0;
            t(0);
          } else {
            o++;
          }
        } else if (0 === c.tag) {
          f[v] = c[0];
        } else if (!u) {
          n[v] = c[0];
          a.add(v);
          if (!s && a.size < i) {
            if (!l) {
              for (var h in r) {
                if (!a.has(h)) {
                  (f[h] || e)(0);
                }
              }
            } else {
              l = !1;
            }
          } else {
            s = !0;
            l = !1;
            t(push(Array.isArray(n) ? n.slice() : {
              ...n
            }));
          }
        }
      }));
    };
    for (var v in r) {
      loop(v);
    }
    t(start((e => {
      if (u) {} else if (1 === e) {
        u = !0;
        for (var r in f) {
          f[r](1);
        }
      } else if (!l) {
        l = !0;
        for (var i in f) {
          f[i](0);
        }
      }
    })));
  };
}

function combine(...e) {
  return zip(e);
}

var observableSymbol = () => Symbol.observable || "@@observable";

function fromObservable(e) {
  e = e[observableSymbol()] ? e[observableSymbol()]() : e;
  return r => {
    var i = e.subscribe({
      next(e) {
        r(push(e));
      },
      complete() {
        r(0);
      },
      error() {}
    });
    r(start((e => {
      if (1 === e) {
        i.unsubscribe();
      }
    })));
  };
}

function toObservable(r) {
  return {
    subscribe(i) {
      var t = e;
      var a = !1;
      r((e => {
        if (a) {} else if (0 === e) {
          a = !0;
          i.complete();
        } else if (0 === e.tag) {
          (t = e[0])(0);
        } else {
          i.next(e[0]);
          t(0);
        }
      }));
      var f = {
        closed: !1,
        unsubscribe() {
          f.closed = !0;
          a = !0;
          t(1);
        }
      };
      return f;
    },
    [observableSymbol()]() {
      return this;
    }
  };
}

function fromCallbag(e) {
  return r => {
    e(0, ((e, i) => {
      if (0 === e) {
        r(start((e => {
          i(e + 1);
        })));
      } else if (1 === e) {
        r(push(i));
      } else {
        r(0);
      }
    }));
  };
}

function toCallbag(e) {
  return (r, i) => {
    if (0 === r) {
      e((e => {
        if (0 === e) {
          i(2);
        } else if (0 === e.tag) {
          i(0, (r => {
            if (r < 3) {
              e[0](r - 1);
            }
          }));
        } else {
          i(1, e[0]);
        }
      }));
    }
  };
}

function pipe(...e) {
  var r = e[0];
  for (var i = 1, t = e.length; i < t; i++) {
    r = e[i](r);
  }
  return r;
}


//# sourceMappingURL=wonka.mjs.map


/***/ })

}]);